<div class="left-modal full dark">
  <div class="close"  (click)="close()"></div>
  @if (editable && userId == images[position].user_id) {
    <div class="delete"  (click)="delete()"></div>
  }
  @if (editable && showEditButton && userId == images[position].user_id) {
    <div class="edit"  (click)="edit()"></div>
  }
  @if (editable && showEditButton) {
    <i (click)="rotate(img)" [ngStyle]="{'top': (userId == images[position].user_id ? 105 : 20) + 'px' }" class="material-icons rotate">rotate_right</i>
  }
  @if (images[position].wasRotated) {
    <i (click)="save()" [ngStyle]="{'top': (userId == images[position].user_id ? 145 : 60) + 'px'}" class="material-icons-outlined save">save</i>
  }
  <div class="full-image" (swipeleft)="previous()" (swiperight)="next()">
    <div class="slider-arrow next" (click)="next()"></div>
    <div class="slider-arrow previous" (click)="previous()"></div>
    <div class="imageConteiner" appImagefull [img]="img">
      <img #img [src]="images[position].image_url" imageLoader imageFull="true" (load)="loadImage()">
      <ng-container>
        <div class="cont_detail">
          <div class="day">
            {{images[position].day_of_history}}
          </div>
          <div class="detail">
            <span class="uppercase">{{view | translate}} {{images[position].character_name}}</span>
            @if (images[position].tittle || images[position].title) {
              <span> {{images[position].tittle || images[position].title}}</span>
            }
            <span>{{'Uploaded' | translate}}: {{images[position].user_name}}</span>
          </div>
        </div>
        <!-- <div class="cont_text">{{images[position].character_name}} <br> {{images[position].tittle}}</div> -->
      </ng-container>

    </div>
  </div>
</div>
@if (view == 'delete') {
  <div class="delete-modal center-modal">
    <div class="close" (click)="view = ''"></div>
    @if (!loading) {
      <div class="modal-container">
        <h1>{{'Delete image' | translate}}</h1>
        <form #form="ngForm" (ngSubmit)="deleteConfirm()" novalidate>
          <div class="L-12 M-12 S-12 columns TextCentered">
            <input name="sumbit" type="submit" value="{{'Confirm' | translate}}">
          </div>
          <div class="L-12 M-12 S-12 columns TextCentered">
            <a class="button cancel" (click)="view = ''">{{'Cancel' | translate}}</a>
          </div>
        </form>
      </div>
    }
  </div>
}
@if (view == 'save') {
  <div class="center-modal">
    <div class="close" (click)="view = ''"></div>
    @if (!loading) {
      <div class="modal-container">
        <h1>{{'Rotate image' | translate}}</h1>
        <form #form="ngForm" (ngSubmit)="saveConfirm()" novalidate>
          <div class="L-12 M-12 S-12 columns TextCentered">
            <input name="sumbit" type="submit" value="{{'Confirm' | translate}}">
          </div>
          <div class="L-12 M-12 S-12 columns TextCentered">
            <a class="button cancel" (click)="view = ''">{{'Cancel' | translate}}</a>
          </div>
        </form>
      </div>
    }
  </div>
}